
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "reset_477fc08aed566615__a",
  width: "200%",
  height: "200%",
  x: "-50%",
  y: "-37.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.859703075 0 0 0 0 0.87142499 0 0 0 0 0.876811594 0 0 0 0.412587413 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "reset_477fc08aed566615__d",
  width: "153.9%",
  height: "153.8%",
  x: "-26.9%",
  y: "-26.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3,
  dy: 2,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "reset_477fc08aed566615__b",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  id: "reset_477fc08aed566615__c",
  d: "m17.307 6.857-4.872 4.886-4.888-4.879-.69.669v.008l4.893 4.89-4.859 4.874.645.695h.011l4.877-4.896 4.875 4.871.702-.668v-.008l-4.891-4.884 4.865-4.884-.657-.674z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#reset_477fc08aed566615__a)",
  xlinkHref: "#reset_477fc08aed566615__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#reset_477fc08aed566615__b"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "var(--theme-primary, #810ea9)",
  xlinkHref: "#reset_477fc08aed566615__c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#reset_477fc08aed566615__d)",
  xlinkHref: "#reset_477fc08aed566615__c"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n    <defs>\r\n        <filter id=\"2voeg80sea\" width=\"200%\" height=\"200%\" x=\"-50%\" y=\"-37.5%\" filterUnits=\"objectBoundingBox\">\r\n            <feOffset dy=\"3\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"3.5\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0.859703075 0 0 0 0 0.87142499 0 0 0 0 0.876811594 0 0 0 0.412587413 0\"/>\r\n        </filter>\r\n        <filter id=\"el718jfxnd\" width=\"153.9%\" height=\"153.8%\" x=\"-26.9%\" y=\"-26.9%\" filterUnits=\"objectBoundingBox\">\r\n            <feGaussianBlur in=\"SourceAlpha\" result=\"shadowBlurInner1\" stdDeviation=\"1.5\"/>\r\n            <feOffset dx=\"3\" dy=\"2\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"/>\r\n            <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" k2=\"-1\" k3=\"1\" operator=\"arithmetic\" result=\"shadowInnerInner1\"/>\r\n            <feColorMatrix in=\"shadowInnerInner1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0\"/>\r\n        </filter>\r\n        <circle id=\"59jriegrwb\" cx=\"12\" cy=\"12\" r=\"12\"/>\r\n        <path id=\"z7gvgc7pic\" d=\"M17.307 6.857L12.435 11.743 7.547 6.864 6.857 7.533 6.857 7.541 11.75 12.431 6.891 17.305 7.536 18 7.547 18 12.424 13.104 17.299 17.975 18.001 17.307 18.001 17.299 13.11 12.415 17.975 7.531 17.318 6.857z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g transform=\"translate(-32 -272) translate(32 272)\">\r\n                    <use fill=\"#000\" filter=\"url(#2voeg80sea)\" xlink:href=\"#59jriegrwb\"/>\r\n                    <use fill=\"#FFF\" xlink:href=\"#59jriegrwb\"/>\r\n                </g>\r\n                <g transform=\"translate(-32 -272) translate(32 272)\">\r\n                    <use fill=\"var(--theme-primary, #810ea9)\" xlink:href=\"#z7gvgc7pic\"/>\r\n                    <use fill=\"#000\" filter=\"url(#el718jfxnd)\" xlink:href=\"#z7gvgc7pic\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/reset.477fc08aed5666153d16c222f1939532.svg"),
        {
          React: SvgReset,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      